import { FormattedMessage, useIntl } from "react-intl";
import { ADMIN, MASTER_DATA_EDITOR, MASTER_DATA_VIEWER } from "../../../common/constant";

import { faCheck, faEdit, faPlus, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { useState } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  ButtonGroup,
  ButtonToolbar,
  FormControl,
  FormGroup,
  FormLabel,
  FormSelect
} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import { handleSortList } from "../../../utils/MasterDataManagementUtils";
import { getOptionTextFromValue } from "../../../utils/OptionsUtils";
import SurveyUtils from "../../../utils/SurveyUtils";
import Checkbox from "../../common/Checkbox";
import StandardView from "../../common/StandardView";
import Visibility from "../../common/VisibleContainer";

const NAME_COLUMN_NAME = "name";

const MasterDataManagement = ({
  clearMessages,
  loadMasterData,
  loadUniversities,
  fundingAreaList,

  editProgramDialogOpen,
  editProgramInstanceDialogOpen,
  editProjectDialogOpen,
  editProgram,
  editedProgram,
  editProgramInstance,
  editProject,
  selectedFundingArea,
  selectedProgram,
  selectedProgramInstance,
  deleteProgramInstance,
  deleteProgram,
  deleteProjectWithReferenceCheck,

  createNewProject,
  createNewProgramInstance,
  createNewProgram,

  programChange,
  editedProgramInstance,
  editedProject,
  saveProject,
  saveProgram,
  saveProgramInstance,
  programDialogOpenChange,
  programInstanceChange,
  programInstanceDialogOpenChange,
  projectChange,
  projectDialogOpenChange,

  countryOptions,
  regionsOptions,
  lectorateTypeOptions
}) => {
  const [activeOnly, setActiveOnly] = useState(false);
  const [sortTableAscending, setSortTableAscending] = useState(false);
  const [sortTableTemplateBy, setSortTableTemplateBy] = useState("");

  const intl = useIntl();

  function onSortColumn(columnType) {
    setSortTableAscending(sortTableTemplateBy === columnType ? !sortTableAscending : true);
    setSortTableTemplateBy(columnType);
  }

  function getFunctionToGetContent(columnLabel, extraColumns) {
    const extraColumn = extraColumns.find(extraColumn => extraColumn.label === columnLabel);
    if (extraColumn) {
      if (extraColumn.key) {
        return (row) => row[extraColumn.key];
      }

      if (extraColumn.getContent) {
        return extraColumn.getContent;
      }
    }


    return (row) => row[columnLabel];
  }

  const isProjectLevel = selectedProgramInstance !== undefined;
  const isProgramInstanceLevel = selectedProgram !== undefined && !isProjectLevel;
  const isProgramLevel = selectedFundingArea !== undefined && !isProgramInstanceLevel && !isProjectLevel;
  const isLectorate = SurveyUtils.isSemesterTypeProgram(selectedProgram?.name);

  let rows = fundingAreaList || [];
  let navLink = (id, name) => <Link to={`/userArea/masterDataManagement/${id}`}>{name}</Link>;
  let type = "master.data.management.funding.area";
  let extraColumns = [
    {
      label: "master.data.management.program.instance.foreignid",
      key: "foreignId"
    }
  ];
  let actions = [];

  if (isProgramLevel) {
    rows = selectedFundingArea.programs;
    navLink = (id, name) => <Link to={`/userArea/masterDataManagement/${selectedFundingArea.id}/${id}`}>{name}</Link>;
    type = "master.data.management.program";
    actions = [
      {
        roles: [MASTER_DATA_EDITOR],
        onClick: editProgram,
        condition: (program) => program.category && program.category === "IND",
        labelKey: "master.data.management.edit",
        icon: faEdit
      },
      {
        roles: [MASTER_DATA_EDITOR],
        condition: (program) => program.category && program.category === "IND" && program.programInstances.length === 0,
        onClick: (id) => {
          deleteProgram(id);
        },
        labelKey: "app.common.action.delete",
        icon: faTrash,
        className: "text-danger"
      }
    ];
    extraColumns = [
      {
        label: "master.data.management.program.foreignid",
        key: "foreignId"
      }
    ];
  }

  if (isProgramInstanceLevel) {
    rows = selectedProgram.programInstances;
    navLink = (id, name) => (
      <Link to={`/userArea/masterDataManagement/${selectedFundingArea.id}/${selectedProgram.id}/${id}`}>{name}</Link>
    );
    type = "master.data.management.program.instance";
    actions = [
      {
        roles: [MASTER_DATA_EDITOR],
        onClick: editProgramInstance,
        condition: (programInstance) => programInstance.category && programInstance.category === "IND",
        labelKey: "master.data.management.edit",
        icon: faEdit
      },
      {
        roles: [MASTER_DATA_EDITOR],
        condition: (programInstance) =>
          programInstance.category && programInstance.category === "IND" && programInstance.projects.length === 0,
        onClick: (id) => {
          deleteProgramInstance(id);
        },
        labelKey: "app.common.action.delete",
        icon: faTrash,
        className: "text-danger"
      }
    ];
    extraColumns = [
      {
        label: "master.data.management.program.instance.foreignid",
        key: "foreignId"
      }
    ];
  }

  if (isProjectLevel) {
    rows = selectedProgramInstance.projects.filter((project) => !activeOnly || !project.obsolete);
    navLink = undefined;
    type = isLectorate ? "master.data.management.lectorate" : "master.data.management.project";
    actions = [
      {
        roles: [MASTER_DATA_EDITOR],
        condition: (project) => project.category === "IND",
        onClick: editProject,
        labelKey: "master.data.management.edit",
        icon: faEdit
      },
      {
        roles: [MASTER_DATA_EDITOR],
        condition: (project) => project.category === "IND",
        onClick: (projectId) => {
          deleteProjectWithReferenceCheck(projectId);
        },
        labelKey: "app.common.action.delete",
        icon: faTrash,
        className: "text-danger"
      }
    ];
    !isLectorate
      ? (extraColumns = [
          {
            label: "master.data.management.project.foreignid",
            key: "foreignId"
          },
          {
            label: "master.data.management.project.university",
            getContent: (row) => (row.university ? row.university.name : "")
          },
          {
            label: "master.data.management.project.active",
            key: "obsolete",
            getContent: (row) =>
              row.obsolete ? (
                <FontAwesomeIcon
                  icon={faTimes}
                  title={intl.formatMessage({ id: "master.data.management.project.obsolet" })}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faCheck}
                  title={intl.formatMessage({ id: "master.data.management.project.active" })}
                />
              )
          }
        ])
      : (extraColumns = [
          {
            label: "master.data.management.lectorate.foreignid",
            key: "foreignId"
          },
          //{
          //  label: "master.data.management.project.projectType",
          //  getContent: (row) => getOptionTextFromValue(row.projectType, lectorateTypeOptions)
          //},
          {
            label: "master.data.management.project.university",
            getContent: (row) => (row.university ? row.university.name : "")
          },
          {
            label: "master.data.management.project.targetCountry",
            getContent: (row) => getOptionTextFromValue(row.targetCountry, countryOptions)
          },
          {
            label: "master.data.management.project.targetRegion",
            getContent: (row) => getOptionTextFromValue(row.targetRegion, regionsOptions)
          },
          {
            label: "master.data.management.project.active",
            key: "obsolete",
            getContent: (row) =>
              row.obsolete ? (
                <FontAwesomeIcon
                  icon={faTimes}
                  title={intl.formatMessage({ id: "master.data.management.project.obsolet" })}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faCheck}
                  title={intl.formatMessage({ id: "master.data.management.project.active" })}
                />
              )
          }
        ]);
  }

  if (sortTableTemplateBy.length) {
    const getContentFunction = getFunctionToGetContent(sortTableTemplateBy, extraColumns);
    rows = handleSortList(rows, getContentFunction, sortTableAscending);
  }

  return (
    <Visibility roles={[MASTER_DATA_VIEWER]}>
      <StandardView
        id="masterDataManagement"
        titleKey="master.data.management.page.title"
        actions={[
          isProgramLevel && {
            roles: [ADMIN],
            labelKey: "master.data.management.new.program",
            onClick: createNewProgram,
            icon: <FontAwesomeIcon icon={faPlus} className="me-2" />
          },
          isProgramInstanceLevel && {
            roles: [MASTER_DATA_EDITOR],
            labelKey: "master.data.management.new.program.instance",
            onClick: createNewProgramInstance,
            icon: <FontAwesomeIcon icon={faPlus} className="me-2" />
          },
          isProjectLevel && {
            roles: [MASTER_DATA_EDITOR],
            labelKey: "master.data.management.new.project",
            onClick: createNewProject,
            icon: <FontAwesomeIcon icon={faPlus} className="me-2" />
          }
        ]}
      >
        <Breadcrumb>
          <BreadcrumbItem linkAs={Link} linkProps={{ to: "/userArea/masterDataManagement" }}>
            <FormattedMessage id="master.data.management.master.data" />
          </BreadcrumbItem>
          {selectedFundingArea && (
            <BreadcrumbItem
              linkAs={Link}
              linkProps={{ to: `/userArea/masterDataManagement/${selectedFundingArea.id}` }}
              title={selectedFundingArea.name}
            >
              {selectedFundingArea.name}
            </BreadcrumbItem>
          )}
          {selectedProgram && (
            <BreadcrumbItem
              linkAs={Link}
              linkProps={{ to: `/userArea/masterDataManagement/${selectedFundingArea.id}/${selectedProgram.id}` }}
              title={selectedProgram.name || "unbekannt"}
            >
              {selectedProgram.name || "unbekannt"}
            </BreadcrumbItem>
          )}
          {selectedProgramInstance && (
            <BreadcrumbItem
              linkAs={Link}
              linkProps={{
                to: `/userArea/masterDataManagement/${selectedFundingArea.id}/${selectedProgram.id}/${selectedProgramInstance.id}`
              }}
              title={selectedProgramInstance.name}
            >
              {selectedProgramInstance.name}
            </BreadcrumbItem>
          )}
        </Breadcrumb>

        <ButtonToolbar className="mb-2">
          <ButtonGroup className="gap-lg align-items-center">
            <Checkbox
              name="activeOnly"
              value={activeOnly.toString()}
              checked={activeOnly}
              type="checkbox"
              onChange={(e) => setActiveOnly(!(e.target.value === "true"))}
            >
              <FormattedMessage id="master.data.management.table.only.active.projects" />
            </Checkbox>
          </ButtonGroup>
        </ButtonToolbar>

        {rows && (
          <Table striped hover responsive>
            <thead>
              <tr>
                <th key="type">
                  <Button variant="link" onClick={() => onSortColumn(NAME_COLUMN_NAME)}>
                    <FormattedMessage id={type} />
                    {SurveyUtils.sortIcon(NAME_COLUMN_NAME, sortTableTemplateBy, sortTableAscending)}
                  </Button>
                </th>
                {extraColumns.map((col, i) => (
                  <th key={i}>
                    <Button variant="link" onClick={() => onSortColumn(col.label)}>
                      <FormattedMessage id={col.label} />
                      {SurveyUtils.sortIcon(col.label, sortTableTemplateBy, sortTableAscending)}
                    </Button>
                  </th>
                ))}
                <Visibility key="actions" roles={[MASTER_DATA_VIEWER]} as="th" className="actions">
                  <FormattedMessage id="app.common.title.actions" />
                </Visibility>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td>{navLink ? navLink(row.id, row.name || "unbekannt") : <span>{row.name || "unbekannt"}</span>}</td>
                  {extraColumns.map((col) => (
                    <td key={col.label}>{(col.getContent ? col.getContent(row) : row[col.key]) ?? ""}</td>
                  ))}
                  <Visibility roles={[MASTER_DATA_VIEWER]} as="td" className="actions">
                    {actions &&
                      actions.map(
                        (action, i) =>
                          (!action.condition || action.condition(row)) && (
                            <Visibility key={i} roles={action.roles}>
                              <Button
                                size="sm"
                                variant="link"
                                onClick={() => action.onClick(row.id)}
                                title={intl.formatMessage({ id: action.labelKey })}
                              >
                                {action.icon && <FontAwesomeIcon icon={action.icon} className={action.className}/>}
                              </Button>
                            </Visibility>
                          )
                      )}
                  </Visibility>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <Modal show={editProgramDialogOpen} size="lg">
          <Modal.Header>
            <Modal.Title>
              <FormattedMessage
                id={editedProgram.id ? "master.data.management.edit.program" : "master.data.management.new.program"}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup className="mb-3">
              <FormLabel>
                <FormattedMessage id="master.data.management.funding.area" />
              </FormLabel>
              <FormControl disabled name="fundingArea" value={selectedFundingArea ? selectedFundingArea.name : ""} />
            </FormGroup>
            <FormGroup className="mb-3">
              <FormLabel>
                <FormattedMessage id="master.data.management.program.name" />*
              </FormLabel>
              <FormControl
                name="name"
                value={editedProgram.name || ""}
                onChange={(event) => {
                  programChange("name", event.currentTarget.value);
                }}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <FormLabel>
                <FormattedMessage id="master.data.management.program.code" />*
              </FormLabel>
              <FormControl
                name="code"
                disabled={editedProgram.id}
                value={editedProgram.code || ""}
                maxLength={10}
                onChange={(event) => {
                  programChange("code", event.currentTarget.value.replace(/[^a-z^A-Z^0-9^\s]+/, "").toUpperCase());
                }}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <FormLabel>
                <FormattedMessage id="master.data.management.program.foreignid" />*
              </FormLabel>
              <FormControl
                name="foreignid"
                disabled={editedProgram.id}
                value={editedProgram.foreignId || ""}
                onChange={(event) => {
                  programChange("foreignId", event.currentTarget.value);
                }}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => programDialogOpenChange(false)}>
              <FormattedMessage id="master.data.management.button.cancel" />
            </Button>
            <Button
              onClick={saveProgram}
              disabled={
                !editedProgram.name ||
                !editedProgram.foreignId ||
                !editedProgram.code ||
                editedProgram.name.trim().length === 0 ||
                editedProgram.foreignId.trim().length === 0 ||
                editedProgram.code.trim().length === 0
              }
            >
              <FormattedMessage id="master.data.management.button.save" />
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={editProgramInstanceDialogOpen} size="xl">
          <Modal.Header>
            <Modal.Title>
              <FormattedMessage
                id={
                  editedProgramInstance.id
                    ? "master.data.management.edit.program.instance"
                    : "master.data.management.new.program.instance"
                }
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup className="mb-3">
              <FormLabel>
                <FormattedMessage id="master.data.management.program" />
              </FormLabel>
              <FormControl disabled name="program" value={selectedProgram ? selectedProgram.name : ""} />
            </FormGroup>
            {editedProgramInstance.id && (
              <FormGroup className="mb-3">
                <>
                  <FormattedMessage id="master.data.management.program.instance.foreignid" />*
                </>
                <FormControl
                  name="foreignid"
                  disabled={editedProgramInstance.id}
                  value={editedProgramInstance.foreignId || ""}
                  onChange={(event) => {
                    programInstanceChange("foreignId", event.currentTarget.value);
                  }}
                />
              </FormGroup>
            )}
            <FormGroup className="mb-3">
              <FormLabel>
                <FormattedMessage id="master.data.management.program.instance.name" />*
              </FormLabel>
              <FormControl
                name="name"
                value={editedProgramInstance.name || ""}
                onChange={(event) => {
                  programInstanceChange("name", event.currentTarget.value);
                }}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => programInstanceDialogOpenChange(false)}>
              <FormattedMessage id="master.data.management.button.cancel" />
            </Button>
            <Button
              onClick={saveProgramInstance}
              disabled={!editedProgramInstance.name || editedProgramInstance.name.trim().length === 0}
            >
              <FormattedMessage id="master.data.management.button.save" />
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={editProjectDialogOpen} size="lg">
          <Modal.Header>
            <Modal.Title>
              <FormattedMessage
                id={editedProject.id ? "master.data.management.edit.project" : "master.data.management.new.project"}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup className="mb-3">
              <FormLabel>
                <FormattedMessage id="master.data.management.program.instance" />
              </FormLabel>
              <FormControl
                disabled
                name="programInstance"
                value={selectedProgramInstance ? selectedProgramInstance.name : ""}
              />
            </FormGroup>
            {editedProject.id && (
              <FormGroup className="mb-3">
                <FormLabel>
                  <FormattedMessage id="master.data.management.project.foreignid" />*
                </FormLabel>
                <FormControl
                  name="foreignid"
                  disabled
                  value={editedProject.foreignId || ""}
                  onChange={(event) => {
                    projectChange("foreignId", event.currentTarget.value);
                  }}
                />
              </FormGroup>
            )}
            {!editedProject.id && (
              <FormGroup className="mb-3">
                <FormLabel>
                  <FormattedMessage id="master.data.management.project.foreignid" />*
                </FormLabel>
                <FormControl
                  name="foreignid"
                  placeholder="Wird automatisch vergeben, falls das Feld leer bleibt."
                  value={editedProject.foreignId || ""}
                  onChange={(event) => {
                    projectChange("foreignId", event.currentTarget.value);
                  }}
                />
              </FormGroup>
            )}
            <FormGroup className="mb-3">
              <FormLabel>
                {isLectorate ? (<FormattedMessage id="master.data.management.project.name" />):(<FormattedMessage id="master.data.management.project.name" />)}*
              </FormLabel>
              <FormControl
                name="name"
                value={editedProject.name || ""}
                onChange={(event) => {
                  projectChange("name", event.currentTarget.value);
                }}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <FormLabel>
                <FormattedMessage id="master.data.management.project.university" />*
              </FormLabel>
              <FormControl
                name="name"
                value={editedProject.universityName || ""}
                onChange={(event) => {
                  projectChange("universityName", event.currentTarget.value);
                }}
              />
            </FormGroup>
            {false && (
              <FormGroup className="mb-3">
                <FormLabel>
                  <FormattedMessage id="master.data.management.project.projectType" />*
                </FormLabel>

                <FormSelect
                  name="projectType"
                  defaultValue={editedProject.projectType || ""}
                  onChange={(event) => {
                    projectChange("projectType", event.currentTarget.value);
                  }}
                >
                  <option selected value={0}>
                    <FormattedMessage id="user.surveyView.dropdown.choose" />
                  </option>
                  {lectorateTypeOptions.map((option) => (
                    <option key={option.name} value={option.value}>
                      {option.text}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>
            )}
            {isLectorate && (
              <FormGroup className="mb-3">
                <FormLabel>
                  <FormattedMessage id="master.data.management.project.targetCountry" />*
                </FormLabel>

                <FormSelect
                  name="targetCountry"
                  defaultValue={editedProject.targetCountry || ""}
                  onChange={(event) => {
                    projectChange("targetCountry", event.currentTarget.value);
                  }}
                >
                  <option selected value={0}>
                    <FormattedMessage id="user.surveyView.dropdown.choose" />
                  </option>
                  {countryOptions.map((option) => (
                    <option key={option.name} value={option.value}>
                      {option.text}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>
            )}
            {isLectorate && (
              <FormGroup className="mb-3">
                <FormLabel>
                  <FormattedMessage id="master.data.management.project.targetRegion" />*
                </FormLabel>

                <FormSelect
                  name="targetRegion"
                  defaultValue={editedProject.targetRegion || ""}
                  onChange={(event) => {
                    projectChange("targetRegion", event.currentTarget.value);
                  }}
                >
                  <option selected value={0}>
                    <FormattedMessage id="user.surveyView.dropdown.choose" />
                  </option>
                  {regionsOptions.map((option) => (
                    <option key={option.name} value={option.value}>
                      {option.text}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>
            )}

            <FormGroup className="mb-3">
              <Checkbox
                defaultChecked={editedProject.obsolete === true}
                onChange={(e) => projectChange("obsolete", e.target.checked)}
              >
                <FormattedMessage id="respondents.overview.status.OBSOLETE" />
              </Checkbox>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => projectDialogOpenChange(false)}>
              <FormattedMessage id="master.data.management.button.cancel" />
            </Button>
            <Button
              onClick={saveProject}
              disabled={!editedProject.name || !editedProject.universityName || editedProject.name.trim().length === 0}
            >
              <FormattedMessage id="master.data.management.button.save" />
            </Button>
          </Modal.Footer>
        </Modal>
      </StandardView>
    </Visibility>
  );
};

MasterDataManagement.propTypes = {
  fundingAreaList: PropTypes.arrayOf(PropTypes.object),
  selectedFundingArea: PropTypes.object,
  selectedProgram: PropTypes.object,
  selectedProgramInstance: PropTypes.object,
  editedProgram: PropTypes.object,
  editedProgramInstance: PropTypes.object,
  editedProject: PropTypes.object,
  editProgramDialogOpen: PropTypes.bool,
  editProgramInstanceDialogOpen: PropTypes.bool,
  editProjectDialogOpen: PropTypes.bool,

  universityList: PropTypes.arrayOf(PropTypes.object),

  selectFundingArea: PropTypes.func.isRequired,
  selectProgram: PropTypes.func.isRequired,
  selectProgramInstance: PropTypes.func.isRequired,

  loadMasterData: PropTypes.func.isRequired,
  loadUniversities: PropTypes.func.isRequired,

  createNewProgramInstance: PropTypes.func.isRequired,
  createNewProgram: PropTypes.func.isRequired,
  createNewProject: PropTypes.func.isRequired,

  editProgram: PropTypes.func.isRequired,
  editProgramInstance: PropTypes.func.isRequired,
  editProject: PropTypes.func.isRequired,

  deleteProjectWithReferenceCheck: PropTypes.func.isRequired,
  deleteProgramInstance: PropTypes.func.isRequired,
  deleteProgram: PropTypes.func.isRequired,

  saveProgram: PropTypes.func.isRequired,
  saveProgramInstance: PropTypes.func.isRequired,

  saveProject: PropTypes.func.isRequired,
  programChange: PropTypes.func.isRequired,
  programInstanceChange: PropTypes.func.isRequired,

  projectChange: PropTypes.func.isRequired,
  programDialogOpenChange: PropTypes.func.isRequired,
  programInstanceDialogOpenChange: PropTypes.func.isRequired,

  projectDialogOpenChange: PropTypes.func.isRequired,

  clearMessages: PropTypes.func.isRequired
};

export default MasterDataManagement;
